// extracted by mini-css-extract-plugin
export default {"section":"gv-z","inSectionButton":"hv-z","addressCard":"iv-z","disabled":"jv-z","cautionBox":"kv-z","failureBox":"lv-z","fade-out":"mv-z","successBox":"nv-z"};